export enum PlatformApplyChoiceKind {
  FOLLOW_UP = 'follow-up',
  APPLY = 'apply',
}
